import "./SpecialDayOffAdminReportStats.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import CircularProgressbar from "../CircularProgressBar/CircularProgressBar";
import { useSdoAdminReportsProvider } from "../../providers/SdoAdminReportsProvider";
import { SdoPositionsPublishObj, SdoUsageReport } from "../../models/SdoInterface";
import Loader from "../Loader/Loader";
import { submissionReportStatus } from "../SpecialDayOff/SpecialDayOffHelper";
import { months } from "../../constants/dates";
import { download, getWorkBook } from './UsageReportHelper';
import { useProfile } from '../../providers/Profile';

export default function SpecialDayOffAdminReportStats() {
  const profileContext = useProfile();
  const { t } = useTranslation();
  const sdoAdminReportsContext = useSdoAdminReportsProvider();
  const [monthYear, setMonthYear] = useState('');
  const [positionsPublishData, setPositionsPublishData] = useState<SdoPositionsPublishObj>();
  const [sdoUsageReportsData, setSdoUsageReportsData] = useState<SdoUsageReport>();
  const [sdoDateYearExportBtn, setSdoDateYearExportBtn] = useState(false);

  useEffect(() => {
    if (!sdoAdminReportsContext?.sdoUsageReportsData) return;
    setSdoUsageReportsData(sdoAdminReportsContext.sdoUsageReportsData);
    handleShowSdoExportButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoAdminReportsContext.sdoUsageReportsData]);

  useEffect(()=>{
    handleShowSdoExportButton();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[sdoUsageReportsData]);

  useEffect(() => {
    if (!sdoAdminReportsContext.sdoPositionsPublishData?.sdoMonth && !sdoAdminReportsContext.sdoPositionsPublishData?.sdoYear) return;

    setPositionsPublishData(sdoAdminReportsContext.sdoPositionsPublishData);
    setMonthYear(months[Number(sdoAdminReportsContext.sdoPositionsPublishData?.sdoMonth) - 1] + " " + sdoAdminReportsContext.sdoPositionsPublishData?.sdoYear);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const specialDayOffMyRequests = {
    totalRequest: sdoUsageReportsData?.sdoYearlySummary?.totalRequest ?? 0,
    totalApproved: sdoUsageReportsData?.sdoYearlySummary?.totalApproved ?? 0,
    totalDeclined: sdoUsageReportsData?.sdoYearlySummary?.totalDeclined ?? 0,
    totalRevoked: sdoUsageReportsData?.sdoYearlySummary?.totalRevoked ?? 0,
    totalUnused: sdoUsageReportsData?.sdoYearlySummary?.totalUnused ?? 0,
    numberOfPilots: sdoUsageReportsData?.sdoYearlySummary?.numberOfPilots ?? 0,
    applicableSDORequests: sdoUsageReportsData?.sdoYearlySummary?.applicableSDORequests ?? 0
  };

  const getTotalPositions = () => {
    if (!positionsPublishData) return 0;
    return positionsPublishData?.totalPending + positionsPublishData?.totalPublished;
  }

  const handleOpenExcel = () => {
    if(!sdoAdminReportsContext?.sdoUsageReportsData?.sdoSummary) return;
    download('xlsx', getWorkBook(sdoAdminReportsContext?.sdoUsageReportsData, profileContext),sdoAdminReportsContext?.sdoUsageReportsData);
  }

  const handleShowSdoExportButton = () => {
    if(sdoUsageReportsData?.sdoRequests && Object.keys(sdoUsageReportsData?.sdoRequests).length && sdoUsageReportsData?.sdoSummary && Object.keys(sdoUsageReportsData?.sdoSummary).length) 
    setSdoDateYearExportBtn(true);
  }

  return (
    sdoAdminReportsContext.sdoCurrentSubPeriodLoading? <Loader /> : (
      <>
      {sdoAdminReportsContext?.sdoCurrentSubPeriodData?.status === submissionReportStatus.OVERDUE ?
        <div className='sdo-admin-report-stats__notification'>
          <i className='icon-Error-warning' />
          <div className='sdo-admin-report-stats__notification-text'>
            <p className='sdo-admin-report-stats__notification-text1'>{t('specialDayOffAdmin.sdoAdminReportStats.reportUnpublishedNotification1', { monthYear: monthYear, pendingPositions: positionsPublishData?.totalPending ?? 0, totalPositions: getTotalPositions() })}</p>
            <p>{t('specialDayOffAdmin.sdoAdminReportStats.reportUnpublishedNotification2')}</p>
          </div>
        </div>
        :""}

        <div className="sdo-admin-report-stats__container">
          <div className="sdo-admin-report-stats__first-container">
            <div className="sdo-admin-report-stats__date">              
              <span className="sdo-admin-report-stats__date-text">{t("specialDayOffAdmin.sdoAdminReportStats.sdoDate")}</span>
              <span className="sdo-admin-report-stats__date-value">{sdoAdminReportsContext.sdoCurrentSubPeriodData?.year ?? ''}</span>
              {sdoDateYearExportBtn?               
              <button className="sdo-admin-report-stats__date-export-report link-states" onClick={() => handleOpenExcel()}>
                <i className="icon-Export-Icon"></i>&nbsp;&nbsp;{t("specialDayOffAdmin.sdoAdminReportStats.export")}
              </button>
              : ''} 
            </div>
            <div className="sdo-admin-report-stats__chart-header">
              <span className="sdo-admin-report-stats__chart-header-text">{t("specialDayOffAdmin.sdoAdminReportStats.sdoRequests")}</span>
              <CircularProgressbar insideStrokeColor={"#4e13aa"} outsideStrokeColor={specialDayOffMyRequests.totalRequest === 0 ? "#4e13aa" : "#9057eb"} strokeWidth={14} actualValue={specialDayOffMyRequests.totalRequest} totalValue={specialDayOffMyRequests.applicableSDORequests} totalText={false} />
            </div>
            <span className="data__section-divider" />
            <div className="sdo-admin-report-stats__chart-header">
              <span className="sdo-admin-report-stats__chart-header-text">{t("specialDayOffAdmin.sdoAdminReportStats.sdosApproved")}</span>
              <CircularProgressbar insideStrokeColor={"#21711f"} outsideStrokeColor={specialDayOffMyRequests.totalApproved === 0 ? "#21711f" : "#18ad14"} strokeWidth={14} actualValue={specialDayOffMyRequests.totalApproved} totalValue={specialDayOffMyRequests.totalRequest} totalText={true} />
            </div>
            <span className="data__section-divider" />
            <div className="sdo-admin-report-stats__chart-header">
              <span className="sdo-admin-report-stats__chart-header-text">{t("specialDayOffAdmin.sdoAdminReportStats.sdosDeclined")}</span>
              <CircularProgressbar insideStrokeColor={"#a42125"} outsideStrokeColor={(specialDayOffMyRequests.totalDeclined + specialDayOffMyRequests.totalRevoked) === 0 ? "#a42125" : "#dc666a"} strokeWidth={14} actualValue={specialDayOffMyRequests.totalDeclined + specialDayOffMyRequests.totalRevoked} totalValue={specialDayOffMyRequests.totalRequest} totalText={true} />
            </div>
            <span className="data__section-divider" />
            <div className="sdo-admin-report-stats__chart-header">
              <span className="sdo-admin-report-stats__chart-header-text">{t("specialDayOffAdmin.sdoAdminReportStats.sdosUnused")}</span>
              <CircularProgressbar insideStrokeColor={"#00778f"} outsideStrokeColor={specialDayOffMyRequests.totalUnused === 0 ? "#00778f" : "#0aaccc"} strokeWidth={14} actualValue={specialDayOffMyRequests.totalUnused} totalValue={specialDayOffMyRequests.applicableSDORequests} totalText={false} />
            </div>
          </div>
          <div className="sdo-admin-report-stats__second-container">
            <div className="sdo-admin-report-stats__second-title">
              <span>{t("specialDayOffAdmin.sdoAdminReportStats.manageEligibilityCriteria")}</span>
            </div>
            <div className="sdo-admin-report-stats__manage-details">
              <Link to="/sdo-admin-ec" className="sdo-admin-report-stats__manage-details-link">
                <i className="icon-gear link-states"></i>
                <span className="sdo-admin-report-stats__manage-details-text">{t("specialDayOffAdmin.sdoAdminReportStats.manageRequests")}</span>
              </Link>
            </div>
            <div className="sdo-admin-report-stats__manage-details">
              <Link to={{ pathname: '/sdo-admin-ec', state: {setLimitTabZero: 0} }} className="sdo-admin-report-stats__manage-details-link">
                <i className="icon-Calendar link-states"></i>
                <span className="sdo-admin-report-stats__manage-details-text">{t("specialDayOffAdmin.sdoAdminReportStats.sDOAvailablityPerDay")}</span>
              </Link>
            </div>
            <div className="sdo-admin-report-stats__manage-details">
              <Link to="/admin" className="sdo-admin-report-stats__manage-details-link">
                <i className="icon-upload link-states"></i>
                <span className="sdo-admin-report-stats__manage-details-text">{t("specialDayOffAdmin.sdoAdminReportStats.uploadQUALFile")}</span>
              </Link>
            </div>
          </div>
        </div>
      </>
    )
  );
}